import { useContext, useEffect, useState } from 'react';
import { TestingHqContext } from '../../context/TestingHqContext';
import { TestingContext } from '../../context/TestingContext';
import TESTING_PLACE_SCHEDULE_STATUS from '../../constants/testing_place_schedule';
import { get_testing_place_list, get_testing_schedule_list, get_testing_place_schedule_list, get_testing_type, get_testing_list, upsert_testing_place, upsert_testing_place_schedule } from '../../utils/restapi';
import './joins.css';
import ListBody from '../../components/list/ListBody';

const TestingPlaceScheduleJoins = () => {
  const { testingHqs } = useContext(TestingHqContext);
  const { testingObj, setTestingObj } = useContext(TestingContext);

  // 선택상자 목록들
  const [testingTypes, setTestingTypes] = useState([]);
  const [testings, setTestings] = useState([]);
  const [testingPlaces, setTestingPlaces] = useState([]);
  const [testingSchedules, setTestingSchedules] = useState([]);

  const [testingPlaceObj, setTestingPlaceObj] = useState(null);
  const [testingScheduleObj, setTestingScheduleObj] = useState(null);

  // 목록
  const [items, setItems] = useState([]);
  
  // 정렬 관련 상태
  const [sort, setSort] = useState('');
  const [desc, setDesc] = useState('');

  // 시험유형 데이터 가져오기
  const getTestingTypes = async () => {
    console.log('getTestingTypes called');
    try {
      const response = await get_testing_type();
      console.log("getTestingTypes:", response);
      setTestingTypes(response);
    } catch (error) {
      console.error("Error fetching types:", error);
    }
  };

  // 시험에 대한 데이터 가져오기
  const getTesting = async (type) => {
    console.log(`getTesting called : ${type}`);
    try {
      const response = await get_testing_list({ type, page:1, rowsPerPage:1000, sort:'a_testing_id', desc:'desc' });
      console.log("getTesting:", response);
      setTestings(response.lists || response);
    } catch (error) {
      console.error("Error fetching testing:", error);
      setTestings([]);
    }
  };

  // 고사장에 대한 데이터 가져오기
  const getTestingPlaces = async () => {
    console.log(`getTestingPlaces called`);

    const json = {
      testing_id: testingObj?.testing_id || 0, // 수정: ?. 사용
      gcodes: testingHqs.map(hq => hq.code).join(','),
      page: 1,
      rowsPerPage: 1000,
      sort: 'a_gcode,a_code',
    };

    console.log("getTestingPlace params:", json);

    try {
      const response = await get_testing_place_list(json);
      console.log("getTestingPlaces:", response);
      setTestingPlaces(response.lists);
      if(response.lists.length === 1) {
        setTestingPlaceObj(response.lists[0]);
      } else {
        setTestingPlaceObj(null);
      }
    } catch (error) {
      console.error("Error fetching place:", error);
      setTestingPlaces([]);
    }
  };

  // 시험에 대한 일정 데이터 가져오기
  const getTestingSchedules = async () => { 
    console.log(`getTestingSchedules called`);

    const json = {
      testing_id: testingObj?.testing_id || 0,
      page: 1,
      rowsPerPage: 1000,
    };

    console.log("getTestingSchedules params:", json);

    try {
      const response = await get_testing_schedule_list(json);
      console.log("getTestingSchedules:", response);
      setTestingSchedules(response.lists);
      if(response.lists.length === 1) {
        setTestingScheduleObj(response.lists[0]);
      } else {
        setTestingScheduleObj(null);
      }
    } catch (error) {
      console.error("Error fetching schedules:", error);
      setTestingSchedules([]);
    }
  };

  //고사실에 대한 데이터 가져오기
  const getTestingPlaceSchedules = async () => {
    console.log(`getTestingPlaceSchedules called`);

    const json = {
      testing_place_id: testingPlaceObj?.testing_place_id || 0,
      testing_schedule_id: testingScheduleObj?.testing_schedule_id || 0,
      page: 1,
      rowsPerPage: 1000,
      sort: 'a.code',
      desc: 'asc'
    };

    console.log("getTestingPlaceSchedules params:", json);

    try {
      const response = await get_testing_place_schedule_list(json);
      console.log("getTestingPlaceSchedules:", response);
      console.log(`response.lists.length: ${response.lists.length}, testingPlaceObj.rooms: ${testingPlaceObj.rooms}`);

      // 상태가 1, 2, 6인 항목의 개수 세기
      const usedCount = response.lists.filter(item => TESTING_PLACE_SCHEDULE_STATUS.used.includes(parseInt(item.status, 10))).length;
      console.log(`Active count : ${usedCount}`);

      //response.lists.length가 testingPlaceObj.rooms와 같지 않으면 room_no를 기준으로 병합
      if (usedCount !== testingPlaceObj.rooms) {
        const mergedLists = [];
        if (usedCount > testingPlaceObj.rooms) {
          if (testingPlaceObj.rooms !== usedCount) {
            testingPlaceObj.rooms = usedCount;

            await upsert_testing_place({
              testing_place_id: testingPlaceObj.testing_place_id,
              rooms: testingPlaceObj.rooms,
            });
          }
        }

        // 병합 시에도 status 필터링
        for (let i = 1; i <= testingPlaceObj.rooms; i++) {
          const existing = response.lists.find(item =>
            ([1, 2, 6].includes(parseInt(item.status, 10))) &&
            (parseInt(item.code) === i || parseInt(String(item.room_no).split('고사실')[0]) === i)
          );

          if (existing) {
            console.log(`existing.code : ${existing.code}`);
            
            if (existing.code === undefined || existing.code === '') {
              existing.code = String(i);
              existing.status = TESTING_PLACE_SCHEDULE_STATUS.field.join;
            }

            mergedLists.push(existing);
          } else {
            mergedLists.push({
              testing_place_id: testingPlaceObj.testing_place_id,
              testing_schedule_id: testingScheduleObj.testing_schedule_id,
              code: String(i),
              room_no: `${i}고사실`,
              max_users: 0,
              main_teachers: 0,
              sub_teachers: 0,
              data: { seat: { rows: 0, columns: 0 } },
              testingPlaceObj,
              status: TESTING_PLACE_SCHEDULE_STATUS.field.join,
            });
          }
        }
        setItems(mergedLists);
      } else {
        // 각 항목에 placeObj 추가
        const listsWithPlace = response.lists.map((item, idx) => ({
          ...item,
          code: item.code !== undefined && item.code !== '' ? item.code : String(idx + 1),
          testingPlaceObj,
        }));
        setItems(listsWithPlace);
      }
    } catch (error) {
      console.error("Error fetching schedules:", error);
      setItems([]);
    }
  };

  // 시험유형 선택 핸들러
  const handleTestingTypeChange = (e) => {
    console.log('handleTestingTypeChange called');
    const selectedValue = e.target.value;
    setTestingObj({ type: selectedValue });
  };

  // 시험 선택 핸들러
  const handleTestingChange = (e) => {
    console.log('handleTestingChange called');
    const selectedValue = e.target.value;
    const selectedTesting = testings.find(obj => obj.testing_id === parseInt(selectedValue));
    setTestingObj(selectedTesting);
  };

  // 일정 선택 핸들러
  const handleTestingScheduleChange = (e) => {
    console.log('handleTestingScheduleChange called');
    const selectedValue = e.target.value;
    const selectedSchedule = testingSchedules.find(obj => obj.testing_schedule_id === parseInt(selectedValue));
    setTestingScheduleObj(selectedSchedule);
  };

  // 장소 선택 핸들러
  const handleTestingPlaceChange = (e) => {
    console.log('handleTestingPlaceChange called');
    const selectedValue = e.target.value;
    const selectedPlace = testingPlaces.find(obj => obj.testing_place_id === parseInt(selectedValue));
    setTestingPlaceObj(selectedPlace);
  };

  // 고사실 수 변경 핸들러
  const handleTestingPlaceRoomChange = async (e) => {
    console.log('handleTestingPlaceRoomChange called');
    const newRoomCount = parseInt(e.target.value);
    if (isNaN(newRoomCount) || newRoomCount < 0) return;
    
    setTestingPlaceObj(prev => ({
      ...prev,
      rooms: newRoomCount
    }));

    try {
      await upsert_testing_place({
        testing_place_id: testingPlaceObj.testing_place_id,
        rooms: testingPlaceObj.rooms
      });
    } catch (error) {
      console.error("Error updating testing place:", error);
    }
  };

  // 고사실 추가
  const handleAddRoom = () => {
    console.log('handleAddRoom called');
    const newRoomNumber = items.length + 1;
    const newRoom = {
      testing_place_id: testingPlaceObj.testing_place_id,
      testing_schedule_id: testingScheduleObj?.testing_schedule_id || 0,
      code: String(newRoomNumber),
      room_no: `${newRoomNumber}고사실`,
      max_users: 0,
      main_teachers: 0,
      sub_teachers: 0,
      data: { seat: { rows: 0, columns: 0 } },
      status: TESTING_PLACE_SCHEDULE_STATUS.field.join,
      testingPlaceObj,
    };

    setItems(prevItems => [...prevItems, newRoom]);
    setTestingPlaceObj(prev => ({
      ...prev,
      rooms: prev.rooms + 1
    }));
  };

  // 고사실 삭제
  const handleRemoveRoom = (item) => {
    if (window.confirm('고사실을 삭제하시겠습니까?')) {
      console.log(`item.testing_place_schedule_id: ${item?.testing_place_schedule_id}`);

      if(item?.testing_place_schedule_id) {
        // 기존에 있던 고사실인 경우 상태를 '삭제요청'으로 변경
        setItems(prevItems => {
          const newItems = prevItems.map((it) => {
            console.log(`it.testing_place_schedule_id: ${it?.testing_place_schedule_id} vs item.testing_place_schedule_id: ${item?.testing_place_schedule_id} => ${parseInt(it?.testing_place_schedule_id) === parseInt(item?.testing_place_schedule_id)}`);
            if (parseInt(it?.testing_place_schedule_id) === parseInt(item?.testing_place_schedule_id)) {
              return { ...it, status: TESTING_PLACE_SCHEDULE_STATUS.field.delete };
            }
            return it;
          });

          console.log('New Items after deletion request:', newItems, ' length:', newItems.length);

          return newItems;
        });
      } else {
        // 새로 추가된 고사실인 경우 목록에서 제거
        setItems(prevItems => prevItems.filter((o) => o.code !== item.code));
      }
      
      // 고사실 수 감소
      setTestingPlaceObj(prev => ({
        ...prev,
        rooms: prev.rooms > 0 ? prev.rooms - 1 : 0
      }));
    }
  };

  // 고사장 정보 업데이트
  const handleSubmit = async () => {
    console.log('handleSubmit called');
  };

  // 상태 표시
  const displayStatus = (item) => {
    const statusValue = parseInt(item.status, 10);
    if (TESTING_PLACE_SCHEDULE_STATUS.value.includes(statusValue)) {
      const unusedStatuses = [7, 8, 9];
      const usedStatuses = [1, 2, 6];
      const className =
        unusedStatuses.includes(statusValue) ? 'unused' :
        usedStatuses.includes(statusValue) ? 'used' : '';
      return (
        <span className={`status ${className}`}>
          {TESTING_PLACE_SCHEDULE_STATUS.name[statusValue]}
        </span>
      );
    }
    return '';
  };


  // headers에 renderCell 함수를 포함시킴
  const isAddDisabled = !(testingScheduleObj?.testing_schedule_id && testingPlaceObj?.testing_place_id);

  const headers = [
    { 
      name: 'NO.', 
      value: '',
      renderCell: (item) => item.code
    },
    { 
      name: '고사실', 
      value: 'a_room_no',
      renderCell: (item, index) => (
        <input
          type="text"
          value={item.room_no}
          onChange={e => {
            const newValue = e.target.value;
            setItems(prev =>
              prev.map((row, i) =>
                i === index ? { ...row, room_no: newValue, status: TESTING_PLACE_SCHEDULE_STATUS.field.join } : row
              )
            ).then(() => {
              try {
                upsert_testing_place_schedule({
                  testing_place_schedule_id: item?.testing_place_schedule_id,
                  testing_place_id: item?.testing_place_id,
                  testing_schedule_id: item?.testing_schedule_id,
                  name: newValue
                });
              } catch (error) {
                console.error('Error updating testing place schedule:', error);
              }
            });
          }}
        />
      )
    },
    { 
      name: '최대인원', 
      value: 'a_max_users',
      renderCell: (item, index) => (
        <input
          type="number"
          value={item.max_users}
          onChange={e => {
            const newValue = e.target.value;
            setItems(prev =>
              prev.map((row, i) =>
                i === index ? { ...row, max_users: newValue, status: TESTING_PLACE_SCHEDULE_STATUS.field.join } : row
              )
            );

            try {
              upsert_testing_place_schedule({
                testing_place_schedule_id: item?.testing_place_schedule_id,
                testing_place_id: item?.testing_place_id,
                testing_schedule_id: item?.testing_schedule_id,
                room_no: newValue
              });
            } catch (error) {
              console.error('Error updating testing place schedule:', error);
              alert("최대인원을 저장하는데 실패했습니다.");
            }
          }}
        />
      )
    },
    { 
      name: '시험감독(정)', 
      value: '',
      renderCell: (item, index) => <input type="number" value={parseInt(item.main_teachers)} onChange={e => {
        const newValue = e.target.value;
        setItems(prev =>
          prev.map((row, i) =>
            i === index ? { ...row, main_teachers: newValue, status: TESTING_PLACE_SCHEDULE_STATUS.field.join } : row
          )
        );

        try {
          upsert_testing_place_schedule({
            testing_place_schedule_id: item?.testing_place_schedule_id,
            testing_place_id: item?.testing_place_id,
            testing_schedule_id: item?.testing_schedule_id,
            main_teachers: newValue
          });
        } catch (error) {
          console.error('Error updating testing place schedule:', error);
          alert("시험감독(정) 감독관 명수를 저장하는데 실패했습니다.");
        }
      }} />
    },
    { 
      name: '시험감독(부)', 
      value: '',
      renderCell: (item, index) => <input type="number" value={parseInt(item.sub_teachers)} onChange={e => {
        const newValue = e.target.value;
        setItems(prev =>
          prev.map((row, i) =>
            i === index ? { ...row, sub_teachers: newValue, status: TESTING_PLACE_SCHEDULE_STATUS.field.join } : row
          )
        );

        try {
          upsert_testing_place_schedule({
            testing_place_schedule_id: item?.testing_place_schedule_id,
            testing_place_id: item?.testing_place_id,
            testing_schedule_id: item?.testing_schedule_id,
            sub_teachers: newValue
          });
        } catch (error) {
          console.error('Error updating testing place schedule:', error);
          alert("시험감독(부) 감독관 명수를 저장하는데 실패했습니다.");
        }
      }} />
    },
    {
      name: '좌석배치',
      value: '',
      renderCell: (item) => <div>
        <label>행</label>
        <span>
          <input type="number" value={parseInt(item.data?.seat?.columns || 0)} onChange={e => {
            const newValue = e.target.value;
            setItems(prev =>
              prev.map((row) =>
                row.code === item.code ? {
                  ...row,
                  data: {
                    ...row.data,
                    seat: {
                      ...row.data?.seat,
                      columns: newValue
                    }
                  },
                  status: TESTING_PLACE_SCHEDULE_STATUS.field.join
                } : row
              )
            );

            try {
              upsert_testing_place_schedule({
                testing_place_schedule_id: item?.testing_place_schedule_id,
                testing_place_id: item?.testing_place_id,
                testing_schedule_id: item?.testing_schedule_id,
                data: {
                  seat: {
                    ...item.data.seat,
                    columns: newValue
                  }
                }
              });
            } catch (error) {
              console.error('Error updating testing place schedule:', error);
            }
          }} className='seat_column'/>
        </span>
        <label>열</label>
        <span>
          <input type="number" value={parseInt(item.data?.seat?.rows || 0)} onChange={e => {
            const newValue = e.target.value;
            setItems(prev =>
              prev.map((row) =>
                row.code === item.code ? {
                  ...row,
                  data: {
                    ...row.data,
                    seat: {
                      ...row.data?.seat,
                      rows: newValue
                    }
                  },
                  status: TESTING_PLACE_SCHEDULE_STATUS.field.join
                } : row
              ));
              try {
                upsert_testing_place_schedule({
                  testing_place_schedule_id: item?.testing_place_schedule_id,
                  testing_place_id: item?.testing_place_id,
                  testing_schedule_id: item?.testing_schedule_id,
                  data: {
                    seat: {
                      ...item.data.seat,
                      rows: newValue
                    }
                  }
                });
              } catch (error) {
                console.error('Error updating testing place schedule:', error);
              }
          }} className='seat_row'/>
        </span>
      </div>
    },
    { 
      name: '상태',
      value: '',
      renderCell: (item) => displayStatus(item)
    },
    { 
      name: <button onClick={handleAddRoom} disabled={isAddDisabled}>추가</button>, 
      value: '',
      renderCell: (item, index) => (
        <button onClick={() => handleRemoveRoom(item, index)}>삭제</button>
      )
    }
  ];

  useEffect(() => {
    getTestingTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (testingHqs.length) getTestingPlaces();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingHqs]);

  useEffect(() => {
    if (testingObj?.type) {
      getTesting(testingObj.type);
      getTestingSchedules();
      getTestingPlaces();
    } else {
      setTestings([]);
      setTestingPlaces([]);
      setTestingSchedules([]);
      setItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj?.type]);

  useEffect(() => {
    if (testingObj && testingObj.testing_id) {
      getTestingSchedules();
      getTestingPlaces();
    } else {
      setTestingPlaces([]);
      setTestingSchedules([]);
      setItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj?.testing_id]);

  useEffect(() => {
    console.log('testing_schedule_id : ', testingScheduleObj?.testing_schedule_id, ' testing_place_id : ', testingPlaceObj?.testing_place_id);
    if (testingScheduleObj && testingScheduleObj.testing_schedule_id && testingPlaceObj && testingPlaceObj.testing_place_id) {
      getTestingPlaceSchedules();
    } else {
      setItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingScheduleObj?.testing_schedule_id, testingPlaceObj?.testing_place_id]);

  return (
    <div id="testing_place_schedule_joins">
      <div className="head">
        <h1>회차별 고사실 설정</h1>
        <span><button onClick={handleSubmit}>저장하기</button></span>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>구분</label>
            <span>
              <select value={testingObj?.type || 0} onChange={handleTestingTypeChange}>
                <option value="">▒ 구분 ▒</option>
                {testingTypes.map((obj, index) => (
                  <option key={index} value={obj.code}>
                    {obj.nickname || obj.name}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>시험</label>
            <span>
              <select value={testingObj?.testing_id || 0} onChange={handleTestingChange}>
                <option value="">▒ 시험 ▒</option>
                {testings.map((obj, index) => (
                  <option key={index} value={obj.testing_id}>
                    {obj.title}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>일정</label>
            <span>
              <select value={testingScheduleObj?.testing_schedule_id || 0} onChange={handleTestingScheduleChange}>
                <option value="">▒ 일정 ▒</option>
                {testingSchedules.map((obj, index) => (
                  <option key={index} value={obj.testing_schedule_id}>
                    {obj.testStartDate} ~ {obj.testStopDate}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>고사장</label>
            <span>
              <select value={testingPlaceObj?.testing_place_id || 0} onChange={handleTestingPlaceChange}>
                <option value="">▒ 고사장 ▒</option>
                {testingPlaces.map((obj, index) => (
                  <option key={index} value={obj.testing_place_id}>
                    {obj.name}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>고사실 수</label>
            <span>
              <input type="number" value={testingPlaceObj?.rooms || 0} onChange={handleTestingPlaceRoomChange} />
            </span>
          </li>
        </ul>
        <ListBody
          headers={headers}
          items={items}
          sort={sort}
          desc={desc}
          setSort={setSort}
          setDesc={setDesc}
          className="place_table"
        />
      </div>
      <div className="foot">
        <button onClick={handleSubmit}>저장하기</button>
      </div>
    </div>
  );
};

export default TestingPlaceScheduleJoins;